import { render, staticRenderFns } from "./SidebarAdmin.vue?vue&type=template&id=62e8f448&"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js&"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports